/**
 * Created by chenggong on 2018/3/30.
 */

// Token
export const SET_TOKEN = 'SET_TOKEN'

// 用户数据
export const SET_USERINFO = 'SET_USERINFO'

// 导航菜单
export const SET_NAVMENU = 'SET_NAVMENU'

// 部门列表
export const SET_DEPTLIST = 'SET_DEPTLIST'

// 商品主数据
export const SET_PRODUCTLIST = 'SET_PRODUCTLIST'

// 销售订单数据汇总
export const SET_DASHBROAD = 'SET_DASHBROAD'
export const SET_SALEINDEX = 'SET_SALEINDEX'

// 销售-物料组汇总
export const SET_SALECATEGORY = 'SET_SALECATEGORY'

// 销售-销售订单列表、详情
export const SET_SALEORDERLIST = 'SET_SALEORDERLIST'
export const SET_SALEORDERDETAIL = 'SET_SALEORDERDETAIL'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js